import axiosInstance from '@/utils/api.js'

var state = {
  dhcpLease: [],
  dhcpLeaseActive: [],
  dhcpLeaseExpired: []
}

var getters = {
  DHCP_LEASE: (state) => {
    return state.dhcpLease
  },
  DHCP_LEASE_ACTIVE: (state) => {
    return state.dhcpLeaseActive
  },
  DHCP_LEASE_EXPIRED: (state) => {
    return state.dhcpLeaseExpired
  }
}

var mutations = {
  SET_DHCP_LEASE: (state, payload) => {
    state.dhcpLease = payload
  },
  SET_DHCP_LEASE_ACTIVE: (state, payload) => {
    state.dhcpLeaseActive = payload
  },
  SET_DHCP_LEASE_EXPIRED: (state, payload) => {
    state.dhcpLeaseExpired = payload
  }
}

var actions = {
  GET_DHCP_LEASE: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_leases')
    if (result.status === 200) {
      context.commit('SET_DHCP_LEASE', result.data)
    }
  },
  GET_DHCP_LEASE_ACTIVE: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_leases_active')
    if (result.status === 200) {
      context.commit('SET_DHCP_LEASE_ACTIVE', result.data)
    }
  },
  GET_DHCP_LEASE_EXPIRED: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_leases_expired')
    if (result.status === 200) {
      context.commit('SET_DHCP_LEASE_EXPIRED', result.data)
    }
  },
  EXPIRE_DHCP_LEASE: (context, payload) => {
    return axiosInstance.put('/inventory/expire_dhcp_lease', payload)
  },
  DELETE_DHCP_LEASE: (context, payload) => {
    return axiosInstance.delete('/inventory/dhcp_lease?lease_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/inventory/dhcpLease.js